module.exports = __webpack_public_path__ + "static/img/yytx18.95f9e73.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/yytx18.png
// module id = 890
// module chunks = 0